import { OnSchedHelpers } from "."

// Injected Stylesheet functions/utils
const themeColors = {
  theme_primary: { "primary": { "primary-color": '#6e75f8', "dark-purple": '#1f1d30', "secondary-dark-purple": '#323041', "light-purple": '#6e75f8', "secondary-light-purple": '#C5C8FC', "text-dark": '#2A2653', "text-light": '#7c83f8', "secondary-text-light": '#B0B0B3', "secondary-text-dark": '#495057', "background": '#fff', "border": '#D8D8D8', "success": '#4CAF50', "danger": '#c55050' }},
  theme_dark:    { "dark": { "primary-color": '#fff', "dark-purple": '#fff', "secondary-dark-purple": '#323041', "light-purple": '#6e75f8', "secondary-light-purple": '#C5C8FC', "text-dark": '#cccad7', "text-light": '#cccad7', "secondary-text-light": '#B0B0B3', "secondary-text-dark": '#495057', "background": '#1f1d30', "border": '#D8D8D8', "success": '#4CAF50', "danger": '#c55050' }},
  theme_light:   { "light": { "primary-color": 'lightblue', "dark-purple": '#1f1d30', "secondary-dark-purple": '#323041', "light-purple": '#6e75f8', "secondary-light-purple": '#C5C8FC', "text-dark": '#2A2653', "text-light": '#7c83f8', "secondary-text-light": '#B0B0B3', "secondary-text-dark": '#495057', "background": '#fff', "border": '#D8D8D8', "success": '#4CAF50', "danger": '#c55050' }},
}

export const CurrentTheme = (element) => {
  let currentThemeType = element.onsched.theme?.length ? element.onsched.theme : 'primary'
  return themeColors['theme_' + currentThemeType][currentThemeType]  
}

const injectStyleTag = (css, cssId) => {
  const startEndCss = '/*' + cssId + '*/';

  const injectableCSS = startEndCss + css + startEndCss;

  let styleTag = document.getElementById('injected-stylesheet');

  if (!styleTag?.toString().length) {
    const head = document.head || document.getElementsByTagName('head')[0];
    styleTag = document.createElement('style');
    styleTag.id = 'injected-stylesheet';
  
    head.appendChild(styleTag);
  }

  
  if (styleTag.styleSheet){
    // This is required for IE8 and below.
    styleTag.styleSheet.cssText = injectableCSS;
    if (styleTag.styleSheet.cssText.includes(injectableCSS)) {
      // Contains CSS already
    }
    else {
      // Needs CSS injected
    }
  } else {
    if (styleTag.innerText.includes(injectableCSS)) {
      // Contains CSS already
    }
    else {
      // Needs CSS injected
    }
    styleTag.appendChild(document.createTextNode(injectableCSS));
  }
}

// Injected Stylesheet CSS Templates
const cssTemplates = {
  calendarPopup: (currentTheme, elApptOffsets, elCalendarOffsets, elAppt) => `
    .onsched-full-calendar-modal {
      position: absolute;
      animation: fadeIn 250ms 1 forwards;
    }
    .md .onsched-full-calendar-modal {
      animation: popInModal 250ms 1 forwards;
      height: unset;
    }
    @keyframes popInModal {
      0% { 
        top: ${elApptOffsets.top}px;
        left: ${elApptOffsets.left - 224}px;
        opacity: 0;
      }
      100% {
        top: ${elApptOffsets.top}px;
        left: ${elApptOffsets.left}px;
        opacity: 1;
      }
    }
    @keyframes fadeIn {
      0% { 
        opacity: 0; 
        top: ${elAppt ? -224 : elApptOffsets.top - 224}px;
        left: 0px;
      }
      100% { 
        opacity: 1; 
        top: ${elAppt ? 50 : elApptOffsets.top}px;
        left: 0px;
      }
    }
  `,
}

// Injected Styles
export const CalendarPopupStylesheet = (element, e) => {
  const elAppt = e.el;
  const elCalendar = document.getElementById(element.id);
  const elTimesContainer = document.querySelector('.fc-scroller-liquid-absolute');

  const elCalendarOffsets = {
    width: elCalendar.clientWidth,
    height: elCalendar.clientHeight - elTimesContainer.scrollTop,
    top: elCalendar.offsetTop,
    left: elCalendar.offsetLeft,
  }
  
  let elApptOffsets = {};

  if (elAppt) {
    elApptOffsets = {
      width: elAppt.clientWidth,
      height: elAppt.clientHeight,
      top: (e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].pageY : e.jsEvent.pageY) - elCalendarOffsets.top - (200 * OnSchedHelpers.GetCalendarPostion(e).positionY),
      left: (e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].pageX : e.jsEvent.pageX) - elCalendarOffsets.left - (224 * OnSchedHelpers.GetCalendarPostion(e).positionX)
    }
  }
  else {
    elApptOffsets = {
      width: e.dayEl.clientWidth,
      height: e.jsEvent.target.clientHeight,
      top: (e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].pageY : e.jsEvent.pageY) - elCalendarOffsets.top - (111 * OnSchedHelpers.GetCalendarPostion(e).positionY),
      left: (e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].pageX : e.jsEvent.pageX) - elCalendarOffsets.left - (224 * OnSchedHelpers.GetCalendarPostion(e).positionX)
    }
  }

  const css = cssTemplates.calendarPopup(CurrentTheme(element), elApptOffsets, elCalendarOffsets, elAppt);

  injectStyleTag(css, 'calendarPopup');
}